export default "__VITE_ASSET__DoW7bB2U__"